<section class="index h-75 d-flex">
  <div class="container container-wrapper h-100">
    <div class="row h-100 justify-content-center align-items-center text-center">
      <div class="col-12 col-xl-11">
        <h2 *ngIf='!maintenanceWebshopText && !maintenanceMessage'>
          {{ 'Maintenance' | translate }}
        </h2>
        <h2 *ngIf='maintenanceWebshopText'>
          {{ maintenanceWebshopText | translate }}
        </h2>
        <h2 *ngIf='maintenanceMessage'>
          {{ maintenanceMessage | translate }}
        </h2>
      </div>
    </div>
  </div>
</section>
